import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown, DropdownButton } from 'react-bootstrap'
import Select from 'react-select'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'
import LoyaltyHistory from 'pages/main/clients/LoyaltyHistory'
import Representatives from 'pages/main/organizations/Representatives'
import LoyaltyRedeem from 'pages/main/organizations/LoyaltyRedeem'

import { httpOk, POST, PUT, GET, FILE } from 'helpers/api'
import { formatDate, regexPhoneNumber, formatMoney, formatMoneyInput, returnSign, findKeyFromArrayByValue, notify } from 'helpers/helpers'

function Index() {
	const { t } = useTranslation()

	const statuses = [
		{ 'id': 1, 'name': t('success') },
		{ 'id': -1, 'name': t('deleted') }
	]

	const [data, setData] = useState([])
	const [activeTab, setActiveTab] = useState('personal')
	const [countries, setCountries] = useState([])
	const [regions, setRegions] = useState([])
	const [districts, setDistricts] = useState([])
	const [loyaltyServices, setLoyaltyServices] = useState([])
	// Программа кэшбэка — она же группа организации: разбивка с итогами над таблицей
	const [loyaltyGroups, setLoyaltyGroups] = useState([])
	const [checkedIds, setCheckedIds] = useState([])
	const [modalBulkLoyalty, setModalBulkLoyalty] = useState(false)
	const [bulkLoyaltyServiceId, setBulkLoyaltyServiceId] = useState(null)
	const [modalLoyaltyHistory, setModalLoyaltyHistory] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [showModal, setShowModal] = useState(false)
	const [modalDelete, setModalDelete] = useState(false)
	const [modalRestore, setModalRestore] = useState(false)
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const {
		filterData,
		appliedFilterData,
		setAppliedFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		patchFilterData,
		applySearch,
		applyFilters,
		paginate,
		resetToInitialFilters,
	} = useFilterSearchPagination({
		initialFilterData: {
			'status': 1,
			'search': '',
		},
		initialPagination: {
			'url': '/organizations',
			'response': null,
		},
	})

	async function searchWithFilter(passedData = {}) {
		var filterDataCopy = { ...filterData, ...(passedData.filterData || {}) }
		var filterUrl = "/organizations"
		var urlParams = ""

		if (filterDataCopy.country_id)
			urlParams += returnSign(urlParams) + 'country_id=' + filterDataCopy.country_id
		if (filterDataCopy.region_id)
			urlParams += returnSign(urlParams) + 'region_id=' + filterDataCopy.region_id
		if (filterDataCopy.district_id)
			urlParams += returnSign(urlParams) + 'district_id=' + filterDataCopy.district_id
		if (filterDataCopy.status)
			urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		if (filterDataCopy.loyalty_service_id)
			urlParams += returnSign(urlParams) + 'loyalty_service_id=' + filterDataCopy.loyalty_service_id
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		if (`/organizations${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setAppliedFilterData(filterDataCopy)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
			// Выделение живёт в пределах текущей выборки: после фильтра отмеченные могли пропасть из списка
			setCheckedIds([])
		}

		setDropdownIsOpen(false)
	}

	async function getLoyaltyGroups() {
		const response = await GET('/organizations-loyalty-groups')
		if (httpOk(response)) setLoyaltyGroups(response.data)
	}

	// Строка без программы — организации на программе бренда по умолчанию (или вовсе без кэшбэка)
	function loyaltyGroupName(group) {
		if (group.loyalty_service_id) return group.name
		return group.default_service_name
			? `${t('by_default')}: ${group.default_service_name}`
			: t('org_cashback_no_program')
	}

	function loyaltyGroupFilterValue(group) {
		return group.loyalty_service_id ? String(group.loyalty_service_id) : 'default'
	}

	function filterByLoyaltyGroup(group) {
		var value = loyaltyGroupFilterValue(group)
		var nextFilterData = {
			...filterData,
			'loyalty_service_id': String(filterData.loyalty_service_id ?? '') === value ? null : value,
			'page': 0,
		}
		patchFilterData({ 'loyalty_service_id': nextFilterData.loyalty_service_id })
		searchWithFilter({ filterData: nextFilterData })
	}

	function toggleChecked(id, checked) {
		setCheckedIds(checked ? [...checkedIds, id] : checkedIds.filter(item => item !== id))
	}

	function toggleCheckedAll(checked) {
		setCheckedIds(checked ? (data?.data ?? []).map(item => item.id) : [])
	}

	async function updateLoyaltyBulk() {
		const response = await PUT('/organizations-loyalty-bulk', {
			'ids': checkedIds,
			'loyalty_service_id': bulkLoyaltyServiceId,
		}, { loader: true })

		if (httpOk(response)) {
			setModalBulkLoyalty(false)
			searchWithFilter()
			getLoyaltyGroups()
		}
	}

	async function createUpdate() {
		var response;
		var sendData = { ...selectedItem }

		// Автосоздание документов живёт только у контрагента, привязанного к внешней
		// точке: документ отгрузки уезжает туда. У обычного контрагента флаг не
		// показываем и наверх не отправляем — иначе синхронизация чека упадёт.
		if (!sendData.external_pos_id) sendData.auto_create_documents = false

		if (selectedItem.id) response = await PUT('/organizations', sendData, { loader: true })
		if (!selectedItem.id) response = await POST('/organizations', sendData, { loader: true })

		// Кэшбэк: программа и персональный процент сохраняются отдельным запросом, чтобы
		// сохранение карточки не обнуляло договорную ставку
		if (httpOk(response) && selectedItem.id) {
			var isAmount = personalAwardType(selectedItem) === 'amount'
			response = await PUT('/organizations-loyalty', {
				'id': selectedItem.id,
				'loyalty_service_id': selectedItem.loyalty_service_id ?? null,
				'loyalty_percent': isAmount ? null : (selectedItem.loyalty_percent ?? null),
				'loyalty_amount': isAmount ? (selectedItem.loyalty_amount ?? null) : null,
			}, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			getLoyaltyGroups()
			toggleModal()
		}
	}

	async function deleteItem(e) {
		e.preventDefault()

		var sendData = { ...selectedItem }
		sendData.status = -1
		var response = await PUT('/organizations-status', sendData, { loader: true })

		if (httpOk(response)) {
			searchWithFilter()
			toggleModalDelete(false)
		}
	}

	async function restoreItem(e) {
		e.preventDefault();
		var sendData = { ...selectedItem }

		sendData.status = 1
		var response = await PUT('/organizations-status', sendData, { loader: true })

		if (httpOk(response)) {
			searchWithFilter()
			toggleModalRestore(false)
		}
	}

	async function importFromExel(e) {
		let formData = new FormData();
		formData.append("file", e.target.files[0]);

		var response = await FILE('/organizations-excel-import', formData, {}, { loader: true });

		if (httpOk(response)) {
			notify(t('success'), 'success')
			searchWithFilter()
		}

		document.getElementById('actual-btn').value = '';
	}

	function toggleModal(bool = false, item = {}) {
		if (bool) getCountries()
		if (bool && item.id) getLoyaltyServices()
		if (bool && item.id && item.country_id) getRegions(item.country_id)
		if (bool && item.id && item.region_id) getDistricts(item.region_id)


		setActiveTab('personal')
		// numeric приходит с хвостом нулей («5.000») — в поле показываем как набрали бы руками
		if (item.loyalty_percent !== null && item.loyalty_percent !== undefined)
			item = { ...item, 'loyalty_percent': String(Number(item.loyalty_percent)) }
		if (item.loyalty_amount !== null && item.loyalty_amount !== undefined)
			item = { ...item, 'loyalty_amount': String(Number(item.loyalty_amount)) }
		setSelectedItem(item)
		setShowModal(bool)
	}

	// Тип персональной ставки: выбранный в форме или по тому, что сохранено
	function personalAwardType(item) {
		if (item.loyalty_award_type) return item.loyalty_award_type
		return Number(item.loyalty_amount) > 0 ? 'amount' : 'percent'
	}

	// Программа организации — своя или бренда по умолчанию — с базой «по оплатам»
	function isPaymentsProgram(item) {
		var program = item.loyalty_service_id
			? loyaltyServices.find(service => service.id === item.loyalty_service_id)
			: loyaltyServices.find(service => service.is_organization_default)
		return program?.award_basis === 'payments'
	}

	function toggleModalDelete(bool = false, item = {}) {
		setSelectedItem(item)
		setModalDelete(bool)
	}

	function toggleModalRestore(bool = false, item = {}) {
		setSelectedItem(item)
		setModalRestore(bool)
	}

	function resetFilter() {
		resetToInitialFilters((nextFilterData) => {
			searchWithFilter({ filterData: {
				...nextFilterData,
				status: 1,
			} })
		})
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	// async function paginate(page) {
	// 	setFilterData({ ...filterData, 'page': page })
	// }

	async function handleSelectCountry(option) {
		setSelectedItem({ ...selectedItem, 'country_id': option ? option.id : null })

		if (option) getRegions(option.id)
	}

	async function handleSelectRegion(option) {
		setSelectedItem({ ...selectedItem, 'region_id': option ? option.id : null })

		if (option) getDistricts(option.id)
	}

	async function handleSelectDistrict(option) {
		setSelectedItem({ ...selectedItem, 'district_id': option ? option.id : null })
	}

	// Организации назначают программы, созданные для организаций («от суммы» и накопительные)
	async function getLoyaltyServices() {
		const response = await GET('/loyalty/services')
		if (httpOk(response)) setLoyaltyServices(response.data.filter(item => (
			item.audience === 'organizations' && [1, 2].includes(item.loyalty_service_type_id)
		)))
	}

	async function getCountries() {
		const response = await GET('/helper/countries')
		if (httpOk(response)) setCountries(response.data)
	}

	async function getRegions(country_id) {
		const response = await GET(`/helper/regions/${country_id}`)
		if (httpOk(response)) setRegions(response.data)
	}

	async function getDistricts(region_id) {
		const response = await GET(`/helper/districts/${region_id}`)
		if (httpOk(response)) setDistricts(response.data)
	}

	useEffect(() => {
		getCountries()
		getLoyaltyGroups()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('organizations')} [{formatMoney(data?.total)}]
				</h4>
				<div className="d-flex gap-2">
					<button className="btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
					<DropdownButton title={t('action')}>
						<Dropdown.Item as="li" eventKey="1">
							<input id="actual-btn" hidden type="file" onChange={importFromExel} accept=".xlsx, application/vnd.ms-excel" />
							<label htmlFor="actual-btn" className="upload-from-excel">{t('import')}</label>
						</Dropdown.Item>
						<Dropdown.Item as="li" eventKey="2">
							<a href={`${process.env.REACT_APP_DOWNLOAD_DOMAIN}/files/organizations_template.xlsx`} className="upload-from-excel">
								{t('download_template')}
							</a>
						</Dropdown.Item>
					</DropdownButton>
				</div>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="d-flex flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={(search) => applySearch(search, (nextFilterData) => {
										searchWithFilter({ filterData: nextFilterData })
									})}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													options={statuses}
													value={statuses.find(option => option.id === filterData.status) || ''}
													onChange={(option) => patchFilterData({ 'status': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('org_cashback_program')}</label>
												<Select
													isClearable
													options={loyaltyGroups}
													value={loyaltyGroups.find(option => loyaltyGroupFilterValue(option) === String(filterData.loyalty_service_id ?? '')) || ''}
													onChange={(option) => patchFilterData({ 'loyalty_service_id': option ? loyaltyGroupFilterValue(option) : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => loyaltyGroupName(option)}
													getOptionValue={(option) => loyaltyGroupFilterValue(option)}
												/>
											</div>
										</div>
										<div className="row">
											<div className="col-md-4">
												<div className="form-group">
													<label>{t('countries')}</label>
													<Select
														isClearable
														options={countries}
														value={countries.find(option => option.id === filterData.country_id) || ''}
														onChange={(option) => {
															patchFilterData({ 'country_id': option ? option.id : null })
															if (option) getRegions(option.id)
														}}
														placeholder=""
														noOptionsMessage={() => t('list_empty')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
													/>
												</div>
											</div>
											<div className="col-md-4">
												<div className="form-group">
													<label>{t('regions')}</label>
													<Select
														isClearable
														options={regions}
														value={regions.find(option => option.id === filterData.region_id) || ''}
														onChange={(option) => {
															patchFilterData({ 'region_id': option ? option.id : null })
															if (option) getDistricts(option.id)
														}}
														placeholder=""
														noOptionsMessage={() => t('list_empty')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
													/>
												</div>
											</div>
											<div className="col-md-4">
												<div className="form-group">
													<label>{t('districts')}</label>
													<Select
														isClearable
														options={districts}
														value={districts.find(option => option.id === filterData.district_id) || ''}
														onChange={(option) => patchFilterData({ 'district_id': option ? option.id : null })}
														placeholder=""
														noOptionsMessage={() => t('list_empty')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
													/>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => applyFilters((nextFilterData) => {
															searchWithFilter({ filterData: nextFilterData })
														})}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{appliedFilterData.status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{findKeyFromArrayByValue(statuses, 'id', appliedFilterData.status, 'name')}
									</span>
								}
								{appliedFilterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{appliedFilterData.search}</span>
									</span>
								}
								{appliedFilterData.loyalty_service_id &&
									<span className="me-2">
										<b>{t('org_cashback_program')}: </b>
										{loyaltyGroupName(loyaltyGroups.find(group => loyaltyGroupFilterValue(group) === String(appliedFilterData.loyalty_service_id)) || {})}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					{/* Группы кэшбэка: клик по группе — фильтр по ней, повторный клик снимает */}
					{loyaltyGroups.length > 1 &&
						<div className="d-flex flex-wrap gap-2 mb-3">
							{loyaltyGroups.map((group) => {
								var active = String(appliedFilterData.loyalty_service_id ?? '') === loyaltyGroupFilterValue(group)
								return (
									<div key={loyaltyGroupFilterValue(group)}
										className={`border rounded px-3 py-2 cursor ${active ? 'border-primary bg-primary bg-opacity-10' : ''}`}
										style={{ 'minWidth': '190px' }}
										onClick={() => filterByLoyaltyGroup(group)}>
										<div className="fw-600 td-ellipsis" style={{ 'maxWidth': '260px' }} title={loyaltyGroupName(group)}>
											{loyaltyGroupName(group)}
										</div>
										<div className="small text-muted">
											{t('org_members_count', { 'count': group.organizations_count })}
										</div>
										<div className="small d-flex justify-content-between gap-3">
											<span className="text-muted">{t('org_cashback')}</span>
											<span>{formatMoney(group.loyalty_balance)}</span>
										</div>
										<div className="small d-flex justify-content-between gap-3">
											<span className="text-muted">{t('balance')}</span>
											<span className={group.debt < 0 ? 'text-danger' : ''}>{formatMoney(group.debt)}</span>
										</div>
									</div>
								)
							})}
						</div>
					}

					{checkedIds.length > 0 &&
						<div className="d-flex align-items-center gap-2 mb-2">
							<span className="fw-600">{t('org_selected_count', { 'count': checkedIds.length })}</span>
							<button type="button" className="btn btn-sm btn-primary"
								onClick={() => {
									setBulkLoyaltyServiceId(null)
									setModalBulkLoyalty(true)
								}}>
								{t('org_move_to_program')}
							</button>
							<button type="button" className="btn btn-sm btn-outline-secondary"
								onClick={() => setCheckedIds([])}>
								{t('cancel')}
							</button>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">
										<input type="checkbox" className="form-check-input"
											checked={!!data?.data?.length && checkedIds.length === data.data.length}
											onChange={(e) => toggleCheckedAll(e.target.checked)} />
									</th>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('name2')}</th>
									<th style={{ 'width': '10%' }} className="td-ellipsis">{t('short_name')}</th>
									<th style={{ 'width': '10%' }} className="td-ellipsis">{t('phone')}</th>
									<th style={{ 'width': '10%' }} className="td-ellipsis">{t('tin')}</th>
									<th style={{ 'width': '15%' }}>{t("region")}</th>
									<th style={{ 'width': '15%' }}>{t("district")}</th>
									<th style={{ 'width': '20%' }} className="td-ellipsis">{t('note')}</th>
									<th style={{ 'width': '12%' }} className="td-ellipsis">{t('org_cashback_program')}</th>
									<th style={{ 'minWidth': '110px' }} className="td-ellipsis text-end">{t('org_cashback')}</th>
									<th style={{ 'minWidth': '115px' }} className="td-ellipsis text-center">{t('created')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">
											<input type="checkbox" className="form-check-input"
												checked={checkedIds.includes(item.id)}
												onChange={(e) => toggleChecked(item.id, e.target.checked)} />
										</td>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis">
											<span className="link-primary" style={{ 'cursor': 'pointer' }}
												onClick={() => toggleModal(true, item)}>{item.name}</span>
										</td>
										<td className="td-ellipsis">{item.short_name}</td>
										<td className="text-nowrap">{regexPhoneNumber(item.phone)}</td>
										<td>{item.tin}</td>
										<td className="td-ellipsis">{item.region_name}</td>
										<td className="td-ellipsis">{item.district_name}</td>
										<td className="td-ellipsis">{item.note}</td>
										<td className="td-ellipsis" title={item.loyalty_service_name ?? ''}>
											{item.loyalty_service_name ?? <span className="text-muted">{t('by_default')}</span>}
										</td>
										<td className="text-end text-nowrap">{!!Number(item.loyalty_balance) && formatMoney(item.loyalty_balance)}</td>
										<td className="text-center">{formatDate(item.created_at)}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
														{item.status === 1 &&
															<div className="table-dropdown-item text-danger"
																onClick={() => toggleModalDelete(true, item)}>
																<i className="uil-times"></i>
																{t('delete')}
															</div>
														}
														{item.status === -1 &&
															<div className="table-dropdown-item text-success"
																onClick={() => toggleModalRestore(true, item)}>
																<i className="uil-history-alt"></i>
																{t('restore')}
															</div>
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={(page) => {
								paginate(page)
								searchWithFilter({ filterData: { ...filterData, page } })
							}}>
						</FilterPagination>
					}

				</div>
			</div>

			{/* MODAL */}
			<Modal
				show={showModal}
				animation={false}
				dialogClassName="update-modal-width"
				centered
				onHide={() => toggleModal()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{selectedItem.id ?
							<>{t('edit')}</>
							:
							<>{t('create')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="p-0">
					<ul className="nav nav-tabs">
						<li className="nav-item" onClick={() => setActiveTab('personal')}>
							<span className={`nav-link ${activeTab === 'personal' ? 'active ' : ''}`}>{t('main')}</span>
						</li>
						<li className="nav-item" onClick={() => setActiveTab('legal')}>
							<span className={`nav-link ${activeTab === 'legal' ? 'active ' : ''}`}>{t('legal_entity')}</span>
						</li>
						{selectedItem.id &&
							<li className="nav-item" onClick={() => setActiveTab('cashback')}>
								<span className={`nav-link ${activeTab === 'cashback' ? 'active ' : ''}`}>{t('org_cashback')}</span>
							</li>
						}
						{selectedItem.id &&
							<li className="nav-item" onClick={() => setActiveTab('representatives')}>
								<span className={`nav-link ${activeTab === 'representatives' ? 'active ' : ''}`}>{t('org_representatives')}</span>
							</li>
						}
					</ul>

					<form autoComplete="off" className="p-3" style={{ 'height': '500px', 'overflow': 'auto' }}>
						{activeTab === 'personal' &&
							<>
								<div className="form-group">
									<label>{t('name2')}<span className="required-mark">*</span></label>
									<input type="text" className="form-control" name="name"
										value={selectedItem.name ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
								</div>
								<div className="form-group">
									<label>{t('short_name')}</label>
									<input type="text" className="form-control" name="short_name"
										value={selectedItem.short_name ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'short_name': e.target.value })} />
								</div>
								<div className="form-group">
									<label>{t('phone')}</label>
									<input type="number" className="form-control"
										value={selectedItem.phone ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'phone': e.target.value })} />
								</div>
								<div className="form-group">
									<label>{t('note')}</label>
									<input type="text" className="form-control" name="note"
										value={selectedItem.note ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
								</div>
							</>
						}
						{activeTab === 'legal' &&
							<>
								<div className="form-group">
									<label>{t('tin')}</label>
									<input type="number" className="form-control" name="tin"
										value={selectedItem.tin ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'tin': e.target.value })} />
								</div>
								<div className="form-group">
									<label>{t('bank_account')}</label>
									<input type="number" className="form-control" name="checking_account"
										value={selectedItem.checking_account ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'checking_account': e.target.value })} />
								</div>
								<div className="form-group">
									<label>{t('address')}</label>
									<input type="text" className="form-control" name="address"
										value={selectedItem.address ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'address': e.target.value })} />
								</div>
								<div className="form-group">
									<label>{t('debt_limit')}</label>
									<input type="text" className="form-control" name="debt_limit"
										value={selectedItem.debt_limit ?? ''}
										onChange={(e) => setSelectedItem({
											...selectedItem,
											'debt_limit': e.target.value.replace(/[^0-9.]/g, '')
										})} />
								</div>

								<div className="form-group">
									<label>{t('countries')}</label>
									<Select
										menuPlacement="top"
										isClearable
										options={countries}
										value={countries.find(option => option.id === selectedItem.country_id) || ''}
										onChange={(option) => handleSelectCountry(option)}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
								<div className="form-group">
									<label>{t('regions')}</label>
									<Select
										menuPlacement="top"
										isClearable
										options={regions}
										value={regions.find(option => option.id === selectedItem.region_id) || ''}
										onChange={(option) => handleSelectRegion(option)}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
								<div className="form-group">
									<label>{t('districts')}</label>
									<Select
										menuPlacement="top"
										isClearable
										options={districts}
										value={districts.find(option => option.id === selectedItem.district_id) || ''}
										onChange={(option) => handleSelectDistrict(option)}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</>
						}

						{activeTab === 'representatives' && selectedItem.id &&
							<Representatives organization={selectedItem} />
						}

						{activeTab === 'cashback' && selectedItem.id &&
							<>
								<div className="form-group">
									<label>{t('org_cashback_program')}</label>
									<Select
										isClearable
										options={loyaltyServices}
										value={loyaltyServices.find(option => option.id === selectedItem.loyalty_service_id) || ''}
										onChange={(option) => setSelectedItem({ ...selectedItem, 'loyalty_service_id': option ? option.id : null })}
										placeholder={t('org_cashback_program_default')}
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
								{/* Персональная ставка — процент или фиксированная сумма с каждого чека, что-то одно */}
								<div className="form-group">
									<label>{t('org_personal_cashback')}</label>
									<div className="d-flex gap-2">
										{personalAwardType(selectedItem) === 'amount' ?
											<input type="text" className="form-control" name="loyalty_amount"
												value={formatMoneyInput(selectedItem.loyalty_amount ?? '')}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'loyalty_amount': e.target.value.replace(/[^0-9.]/g, '') })} />
											:
											<input type="text" className="form-control" name="loyalty_percent"
												value={selectedItem.loyalty_percent ?? ''}
												onChange={(e) => {
													var value = e.target.value.replace(/[^0-9.]/g, '')
													if (Number(value) > 100) return
													setSelectedItem({ ...selectedItem, 'loyalty_percent': value })
												}} />
										}
										<select className="form-select" style={{ 'width': 'auto' }}
											value={personalAwardType(selectedItem)}
											onChange={(e) => setSelectedItem({
												...selectedItem,
												'loyalty_award_type': e.target.value,
												'loyalty_percent': '',
												'loyalty_amount': '',
											})}>
											<option value="percent">%</option>
											{/* При программе «по оплатам» сумма за чек не начисляется — выбрать её нельзя,
												а уже сохранённую можно только сменить на процент */}
											{(!isPaymentsProgram(selectedItem) || personalAwardType(selectedItem) === 'amount') &&
												<option value="amount">{t('org_award_per_cheque')}</option>
											}
										</select>
									</div>
									<small className="text-muted">{t('org_personal_cashback_hint')}</small>
									{isPaymentsProgram(selectedItem) &&
										<div className={`small mt-1 ${personalAwardType(selectedItem) === 'amount' ? 'text-danger' : 'text-muted'}`}>
											{t('org_personal_amount_payments_hint')}
										</div>
									}
								</div>
								<div className="d-flex justify-content-between align-items-center mb-2">
									<p className="fw-600 vertical-center mb-0">{t('org_cashback_balance')}</p>
									<p className="mb-0">{formatMoney(selectedItem.loyalty_balance ?? 0)}</p>
								</div>
								<button type="button" className="btn btn-outline-primary w-100"
									onClick={() => setModalLoyaltyHistory(true)}>
									{t('loyalty_history')}
								</button>

								{/* Погашение долга баллами: после него обновляем баланс в карточке и список */}
								<LoyaltyRedeem
									organization={selectedItem}
									onRedeemed={(result) => {
										setSelectedItem({ ...selectedItem, 'loyalty_balance': result.points })
										searchWithFilter()
									}} />
							</>
						}

						{selectedItem.id && selectedItem.external_pos_id &&
							<>
								{selectedItem.external_pos_name &&
									<div className="d-flex justify-content-between mb-2">
										<p className="fw-600 vertical-center">{t('external_pos')}</p>
										<p>{selectedItem.external_pos_name}</p>
									</div>
								}

								<div className="d-flex justify-content-between mb-2">
									<p className="fw-600 vertical-center">{t('documents')}</p>
									<div className="form-check form-switch form-switch-lg">
										<input type="checkbox" className="form-check-input" name="auto_create_documents"
											checked={selectedItem?.auto_create_documents ?? false}
											onChange={(e) => setSelectedItem({ ...selectedItem, 'auto_create_documents': e.target.checked })} />
									</div>
								</div>
							</>
						}
					</form>
				</Modal.Body>
				<Modal.Footer >
					<div className="d-flex gap-2 w-100 mt-3">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={() => toggleModal()}>
							{t('cancel')}
						</button>
						<button type="button" className="btn btn-primary w-100"
							onClick={() => createUpdate()}>
							{t('save')}
						</button>
					</div>
				</Modal.Footer>
			</Modal>
			{/* MODAL */}

			{/* История баллов — то же окно, что у гостей */}
			{modalLoyaltyHistory &&
				<LoyaltyHistory
					showModal={modalLoyaltyHistory}
					setShowModal={setModalLoyaltyHistory}
					organization={selectedItem}>
				</LoyaltyHistory>
			}

			{/* MODAL BULK LOYALTY */}
			<Modal show={modalBulkLoyalty} animation={false} centered dialogClassName="update-modal-width"
				onHide={() => setModalBulkLoyalty(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('org_move_to_program')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p className="fw-600">{t('org_selected_count', { 'count': checkedIds.length })}</p>
					<div className="form-group">
						<label>{t('org_cashback_program')}</label>
						<Select
							isClearable
							options={loyaltyGroups.filter(group => group.loyalty_service_id)}
							value={loyaltyGroups.find(group => group.loyalty_service_id && group.loyalty_service_id === bulkLoyaltyServiceId) || ''}
							onChange={(option) => setBulkLoyaltyServiceId(option ? option.loyalty_service_id : null)}
							placeholder={t('org_cashback_program_default')}
							noOptionsMessage={() => t('list_empty')}
							getOptionLabel={(option) => option.name}
							getOptionValue={(option) => option.loyalty_service_id}
						/>
						<small className="text-muted">{t('org_move_to_program_hint')}</small>
					</div>
					<div className="d-flex gap-2 w-100 mt-3">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={() => setModalBulkLoyalty(false)}>
							{t('cancel')}
						</button>
						<button type="button" className="btn btn-primary w-100"
							onClick={() => updateLoyaltyBulk()}>
							{t('save')}
						</button>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL BULK LOYALTY */}

			{/* MODAL DELETE */}
			<Modal show={modalDelete} animation={false} centered dialogClassName="update-modal-width"
 onHide={() => toggleModalDelete()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('delete')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={deleteItem} autoComplete="off">
						<h4>
							{t('are_you_sure_you_want_delete')}
						</h4>
						<h6 className="text-danger">
							{t('delete_text')}.
						</h6>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalDelete()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL DELETE */}

			{/* MODAL RESTORE */}
			<Modal show={modalRestore} animation={false} centered dialogClassName="update-modal-width"
 onHide={() => toggleModalRestore()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('restore')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => restoreItem(e)} autoComplete="off">
						<h5>
							{t('are_you_sure_you_want')} <b>{t('restore')}</b>
						</h5>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalRestore()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-success w-100">{t('confirm')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL RESTORE */}
		</>
	)
}

export default Index
